import { Raycaster, Vector2 } from 'three';
import { centerOfMass } from '../physics/com.js';
import {
  civilizationStatus,
  planetTemperature,
  relativeLuminosity,
  spectralType,
  starTemperature,
} from '../physics/temperature.js';

function colorToCss(hex) {
  return '#' + hex.toString(16).padStart(6, '0');
}

export function createInfoPanel({ camera, getBodies }) {
  const panel = document.createElement('div');
  panel.id = 'info-panel';
  panel.className = 'info-panel';
  panel.style.display = 'none';
  document.body.appendChild(panel);

  const raycaster = new Raycaster();
  const pointer = new Vector2();
  let selectedBody = null;

  function hide() {
    selectedBody = null;
    panel.style.display = 'none';
  }

  function show(body) {
    selectedBody = body;
    panel.style.display = 'block';
    refresh();
  }

  function refresh() {
    if (!selectedBody) return;
    const bodies = getBodies();
    if (!bodies.includes(selectedBody)) {
      hide();
      return;
    }
    const body = selectedBody;
    const R = centerOfMass(bodies);
    const distCom = body.position.distanceTo(R);
    let rows = '';

    if (body.isStar) {
      const T = starTemperature(body.mass);
      const sp = spectralType(T);
      const L = relativeLuminosity(body.mass);
      rows =
        '<div class="muted">质量</div><div>' + body.mass.toFixed(2) + ' M⊙</div>' +
        '<div class="muted">温度</div><div>' + T.toFixed(0) + ' K</div>' +
        '<div class="muted">光谱</div><div>' + sp + '</div>' +
        '<div class="muted">相对亮度</div><div>' + L.toFixed(2) + ' L₀</div>' +
        '<div class="muted">距质心</div><div>' + distCom.toFixed(2) + ' AU</div>';
    } else {
      const T = planetTemperature(body, bodies);
      const st = civilizationStatus(T);
      rows =
        '<div class="muted">质量</div><div>~1 M⊕（试探体）</div>' +
        '<div class="muted">温度</div><div class="accent">' + T.toFixed(0) + ' K</div>' +
        '<div class="muted">文明状态</div><div>' + st.label + '</div>' +
        '<div class="muted">距质心</div><div>' + distCom.toFixed(2) + ' AU</div>';
    }

    panel.innerHTML =
      '<div class="info-head">' +
      '<div class="info-title">' +
      '<span class="swatch" style="background:' + colorToCss(body.color) +
      ';box-shadow:0 0 8px ' + colorToCss(body.color) + '"></span>' +
      '<strong>' + body.name + '</strong></div>' +
      '<button type="button" class="info-close" aria-label="关闭">×</button></div>' +
      '<div class="info-grid">' + rows + '</div>';

    panel.querySelector('.info-close').onclick = (e) => {
      e.stopPropagation();
      hide();
    };
  }

  function onPointerClick(event) {
    if (event.target.closest && (event.target.closest('#time-bar') || event.target.closest('#info-panel') || event.target.closest('.pov-btn'))) {
      return;
    }
    pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
    pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(pointer, camera);
    const bodies = getBodies();
    const meshes = bodies.map((b) => b.mesh);
    const hits = raycaster.intersectObjects(meshes, false);
    if (hits.length > 0) {
      const id = hits[0].object.userData.bodyId;
      const body = bodies.find((b) => b.id === id);
      if (body) show(body);
    } else {
      hide();
    }
  }

  return {
    panel,
    show,
    hide,
    refresh,
    onPointerClick,
    get selected() {
      return selectedBody;
    },
  };
}
